<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'user.details', params: { id: $route.params.id } }"
          >{{ userName }}</router-link
        >
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{
            name: 'user.details',
            hash: '#transactions',
            params: { id: $route.params.id }
          }"
          >Transactions</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <transaction-form :transaction="transaction" />
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import TransactionForm from '@/views/Home/Users/Transactions/components/TransactionForm'

export default {
  components: {
    AppBarNavIcon,
    TransactionForm
  },

  watch: {
    $route() {
      this.getTransaction()
    }
  },

  computed: {
    ...mapState({
      transaction: state => state.transaction.transactionDetails
    }),

    userName() {
      if (!this.transaction) return 'User'
      return parseInt(this.transaction.owner.id) ===
        parseInt(this.$route.params.id)
        ? this.transaction.ownerName
        : this.transaction.renterName
    }
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },

      loading: false
    }
  },

  methods: {
    ...mapActions({
      getTransactionDetails: 'transaction/getTransactionDetails'
    }),

    ...mapMutations({
      clearTransactionDetails: 'transaction/clearTransactionDetails'
    }),

    async getTransaction() {
      this.loading = true
      await this.getTransactionDetails({
        user: this.$route.params.id,
        id: this.$route.params.transactionId
      })
      this.loading = false
    }
  },

  created() {
    this.getTransaction()
  },

  destroyed() {
    this.clearTransactionDetails()
  }
}
</script>
